<div class="detail" *ngFor="let detail of details">
  <app-legend-marker [type]="detail.type" [color]="detail.color"></app-legend-marker>
  {{detail.label}}
  <div class="detail-quantity">{{detail.quantity | number}}</div>
</div>
